<template>
  <div id="app">
    <!-- 1.导航栏 -->
    <yp-navbar ref="navbar" class="no-transparent-navbar" mobileTitle="新闻中心"></yp-navbar>
    <!-- 2.背景图 + 标题 -->
    <page-title-bg first-font="n" title-en="EWS CENTER" title-zh="新闻中心"></page-title-bg>
    <!-- 3.面包屑导航 -->
    <div class="bread-crumbs-container hidden-xs">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/industryNews.html">新闻中心</a></li>
          <li class="active">行业资讯</li>
        </ol>
      </div>
    </div>
    <!-- 2.资讯列表 -->
    <div class="list-container">
      <div class="container">
        <!-- <yp-doc :doc="content"></yp-doc> -->
        <ul class="doc-list">
          <li v-for="(item, index) in listData" :key="index" :class="{ 'first-doc': index === 0, 'img-mode-doc': index === 0 && item.mainImg }" @click="handleClickDoc(item)">
            <!-- <div style="margin-right: 20px;">{{item.id}}</div> -->
            <template v-if="index === 0 && item.mainImg">
              <div class="item-image-content" v-if="item.mainImg">
                <img :src="item.mainImg" alt="" />
              </div>
              <div class="doc-list-item-content">
                <div class="item-title">{{ item.title }}</div>
                <doc-item-date :date="item.createTime" :is-first="true"></doc-item-date>
                <div class="item-desc">{{ item.desc }}</div>
                <div class="read-details"><span>进入详情</span><span>></span></div>
                <!-- <a class="read-details" href="javascript:void;"><span>进入详情</span><span>></span></a> -->
              </div>
            </template>
            <template v-else>
              <doc-item-date :date="item.createTime"></doc-item-date>
              <div class="doc-list-item-content">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-desc">{{ item.desc }}</div>
                <div class="read-details"><span>进入详情</span><span>></span></div>
                <!-- <a class="read-details" href="javascript:void;"><span>进入详情</span><span>></span></a> -->
              </div>
            </template>
          </li>
        </ul>
        <nav aria-label="Page navigation" class="pagination-container">
          <!-- <div class="first-btn btn">首页</div> -->
          <ul class="yp-pagination">
            <li :class="{ 'is-disabled': pageIndex === 1 }" @click="handleFirstPage"><span>首页</span></li>
            <li :class="{ 'is-disabled': pageIndex === 1, 'glyphicon glyphicon-menu-left': true }" @click="handlePrev"></li>
            <li v-for="(item, index) in pages" :key="index" :class="{ 'is-active': item === pageIndex }" @click="handlePageChange(item)">
              <span>{{ item }}</span>
            </li>
            <li :class="{ 'is-disabled': pageIndex === pageCount, 'glyphicon glyphicon-menu-right': true }" @click="handleNext"></li>
            <li :class="{ 'is-disabled': pageIndex === pageCount }" @click="handleLastPage">尾页</li>
          </ul>
          <!-- <div class="last-btn btn">尾页</div> -->
          <div class="pagecount-content">共{{ pageCount }}页</div>
        </nav>
        <!-- <pagination :current-page.sync="pageIndex" :total="total" :page-size="pageSize"></pagination> -->
      </div>
    </div>
    <!-- 5.footer -->
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
// import jsonData from '@/db/industryNews/main.json'
// import YpDoc from '@/components/yp-doc.vue'
// import pagination from '@/components/pagination/index.js'
import YpFooter from '@/components/footer.vue'
import config from '/config.js'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    // YpDoc,
    // pagination,
    YpFooter,
    DocItemDate: {
      functional: true,
      render(h, ctx) {
        const oriDate = ctx.props.date
        const newDate = new Date(oriDate.replace(/-/g, '/'))
        const year = newDate.getFullYear()
        let month = newDate.getMonth() + 1
        let day = newDate.getDate()
        month = ('00' + month).slice(-2)
        day = ('00' + day).slice(-2)
        if (ctx.props.isFirst) {
          return (
            <div class="item-time">
              <span>{day}</span>
              <span>/{month}</span>
              <span>/{year}</span>
            </div>
          )
        }
        return (
          <div class="item-time">
            <span class="item-time-day">{day}</span>
            <span>/{month}</span>
            <span>/{year}</span>
          </div>
        )
      },
    },
  },
  computed: {
    pages() {
      const list = []
      for (let i = 1; i <= this.pageCount; i++) {
        list.push(i)
      }
      return list
    },
    pageCount() {
      return Math.ceil(this.total / this.pageSize)
    },
  },
  data() {
    return {
      listData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 5,
    }
  },
  methods: {
    handleFirstPage() {
      if (this.pageIndex === 1) return
      this.handlePageChange(1)
    },
    handleLastPage() {
      if (this.pageIndex === this.pageCount) return
      this.handlePageChange(this.pageCount)
    },
    handlePrev() {
      if (this.pageIndex === 1) return
      this.handlePageChange(this.pageIndex - 1)
    },
    handleNext() {
      if (this.pageIndex === this.pageCount) return
      this.handlePageChange(this.pageIndex + 1)
    },
    handlePageChange(index) {
      this.pageIndex = index
      this.loadData()
    },
    handleClickDoc(doc) {
      location.href = config.getDocUrl('industryNewsDetails', doc.id)
      // if (window.screen.width <= 768) {
      //   location.href = '/pages/industry-news/' + doc.id
      // }
    },
    loadData() {
      this.handleLoadData({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        title: '',
        newstypecode: '01',
        status: true,
      })
    },
    handleLoadData(query) {
      // 调用接口
      $.ajax({
        url: `${config.apiBaseUrl}/api/v1.0/news/getNewsList`,
        data: query,
        success: (res) => {
          console.log(res)
          const data = res.data
          this.total = data.total
          this.listData = data.data.map((item) => {
            item.createTime = item.createtime || item.createTime
            item.mainImg = item.mainpicture || item.mainImg
            item.desc = item.digest || item.desc
            return item
          })
        },
      })
    },
  },
  beforeMount() {
    if (!window.__INITIAL_STATE__) {
      this.loadData()
    }
  },
  created() {
    Media($(window).width())
    function Media(width) {
      if (width > 750) {
        refreshRem(1920)
      } else {
        refreshRem(750)
      }
    }
    // 根据设计图尺寸计算rem
    function refreshRem(designSize) {
      let html = document.documentElement
      let wW = html.clientWidth // 窗口宽度
      let rem = (wW * 100) / designSize
      document.documentElement.style.fontSize = rem + 'px'
    }
    this.listData = this.$store.state.listData
    this.total = this.$store.state.total
    this.pageIndex = this.$store.state.pageIndex
    this.pageSize = this.$store.state.pageSize
  },
}
</script>
